import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=4d4c8f19&"
import script from "./Default?vue&type=script&lang=js&"
export * from "./Default?vue&type=script&lang=js&"
import style0 from "./Default.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports